import script from "./MobileOperate.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileOperate.vue?vue&type=script&lang=ts&setup=true"

import "./MobileOperate.vue?vue&type=style&index=0&id=fd451ff6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd451ff6"]])

export default __exports__